<div class="flex" style="margin-top: 15px;" *ngIf="organizations && organizations.length > 0">
  <div class="card w-full">
    <div class="p-datatable p-component p-datatable-striped p-datatable-hoverable-rows">
      <p-table
        [(first)]="first"
        [(rows)]="rows"
        [value]="organizations"
        [totalRecords]="totalOrganizations"
        [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
        [paginator]="true"
        [rowsPerPageOptions]="[10,25,50]"
        [lazy]="true"
        (onPage)="onPageChange($event)"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>{{'attribute.name' | transloco}}</th>
            <th>{{'attribute.description' | transloco}}</th>
            <th>{{'attribute.city' | transloco}}</th>
            <th>{{'attribute.country' | transloco}}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-organization>
          <tr *ngIf="!loadingOrganizations">
            <td>
              <span class="p-column-title bold">{{'attribute.name' | transloco}}</span>
              <a [routerLink]="['/management/organizations', organization.uuid, 'details']">
                {{organization.name}}
              </a>
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.description' | transloco}}</span>
              {{organization.description}}
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.city' | transloco}}</span>
              {{organization.city}}
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.country' | transloco}}</span>
              {{organization.country}}
            </td>
          </tr>
          <tr *ngIf="loadingOrganizations">
            <td class="p-3 bold"><p-skeleton height="1em"></p-skeleton></td>
            <td class="p-3 bold"><p-skeleton height="1em"></p-skeleton></td>
            <td class="p-3 bold"><p-skeleton height="1em"></p-skeleton></td>
            <td class="p-3 bold"><p-skeleton height="1em"></p-skeleton></td>
          </tr>
        </ng-template>
        <ng-template pTemplate="summary">
          <div class="flex align-items-center justify-content-between" *ngIf="totalOrganizations == 0">
            {{'pagination.empty' | transloco}}
          </div>
          <div class="flex align-items-center justify-content-between" *ngIf="totalOrganizations > 0">
            Showing {{first+1}}
            to {{(first+rows) >= totalOrganizations ? totalOrganizations : (first+rows)}}
            of {{totalOrganizations}} {{totalOrganizations > 1 ? 'entries':'entry'}}
          </div>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
<div class="flex" style="margin-top: 15px;" *ngIf="organizations && organizations.length == 0">
  <div class="card w-full">
    <p class="text-xl text-center p-6 font-italic">{{'empty.organizations' | transloco}}</p>
  </div>
</div>
<div class="flex" style="margin-top: 15px;" *ngIf="!organizations">
  <div class="card w-full">
    <app-table-skeleton [rows]="14"></app-table-skeleton>
  </div>
</div>
